import { render, staticRenderFns } from "./ElecChoose.vue?vue&type=template&id=765c5232"
import script from "./ElecChoose.vue?vue&type=script&lang=js"
export * from "./ElecChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports